// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.

const colors = {
  paletteOrange4Dark: "#ffe606ff",
  paletteOrange4Light: "#ffe606ff",
  palettePrimary0Dark: "#1cd5e3ff",
  palettePrimary1Dark: "#1531b8ff",
  palettePrimary2Dark: "#4b75ffff",
  palettePrimary3Dark: "#e7f9feff",
  palettePrimary5Dark: "#436fb6ff",
  palettePrimaryActionDark: "#6ef29cff",
  paletteBlue0Dark: "#ffffffff",
  paletteBlue1Dark: "#1b2635ff",
  paletteBlue2Dark: "#abb8c9ff",
  paletteBlue3Dark: "#31a2ceff",
  paletteBlack0Dark: "#ffffffff",
  paletteBlack1Dark: "#abb8c9ff",
  paletteWhite0Dark: "#243040ff",
  paletteWhite1Dark: "#abb8c9ff",
  paletteWhite2Dark: "#3f4d60ff",
  paletteWhite3Dark: "#8d9cb0ff",
  paletteRed0Dark: "#f98991ff",
  paletteRed1Dark: "#a30013ff",
  paletteRed2Dark: "#ffe2e2ff",
  paletteRed3Dark: "#f75c5cff",
  paletteOrange0Dark: "#ffcd38ff",
  paletteOrange1Dark: "#9b5a01ff",
  paletteOrange2Dark: "#ffe8adff",
  paletteOrange3Dark: "#ff6b00ff",
  paletteGreen0Dark: "#01c16fff",
  paletteGreen1Dark: "#1f6648ff",
  paletteGreen2Dark: "#c8eedeff",
  paletteNeutral0Dark: "#3f5470ff",
  paletteNeutral1Dark: "#334762ff",
  paletteNeutral2Dark: "#121c2bff",
  paletteNeutral3Dark: "#20395aff",
  paletteReserved0Dark: "#1f363dff",
  paletteReserved1Dark: "#5e7a83ff",
  paletteReserved2Dark: "#40798cff",
  paletteReserved3Dark: "#70a9a1ff",
  paletteEcharts0Dark: "#5470c6ff",
  paletteEcharts1Dark: "#91cc75ff",
  paletteEcharts2Dark: "#fac858ff",
  paletteEcharts3Dark: "#ee6666ff",
  paletteEcharts4Dark: "#73c0deff",
  paletteEcharts5Dark: "#3ba272ff",
  paletteEcharts6Dark: "#fc8452ff",
  paletteEcharts7Dark: "#9a60b4ff",
  paletteTrans0Dark: "#ffffff0a",
  paletteTrans1Dark: "#ffffff14",
  paletteTrans2Dark: "#ffffff1f",
  paletteTransLight0Dark: "#ffffff0a",
  paletteTrans2Light: "#0000001f",
  paletteTrans1Light: "#00000014",
  paletteTransLight0Light: "#ffffff0a",
  paletteTrans0Light: "#0000000a",
  paletteEcharts0Light: "#5470c6ff",
  paletteEcharts1Light: "#91cc75ff",
  paletteEcharts2Light: "#fac858ff",
  paletteEcharts3Light: "#ee6666ff",
  paletteEcharts4Light: "#73c0deff",
  paletteEcharts5Light: "#3ba272ff",
  paletteEcharts6Light: "#fc8452ff",
  palettePp0Dark:
    "linear-gradient(137.57deg, rgba(10, 16, 72, 1) 0%, rgba(64, 58, 157, 1) 29%, rgba(13, 75, 176, 1) 63%, rgba(24, 39, 174, 1) 100%)",
  palettePp0Light:
    "linear-gradient(137.57deg, rgba(10, 16, 72, 1) 0%, rgba(64, 58, 157, 1) 29%, rgba(13, 75, 176, 1) 63%, rgba(24, 39, 174, 1) 100%)",
  paletteEcharts7Light: "#9a60b4ff",
  paletteReserved1Light: "#5e7a83ff",
  paletteReserved2Light: "#40798cff",
  paletteReserved3Light: "#70a9a1ff",
  paletteReserved0Light: "#1f363dff",
  paletteNeutral0Light: "#cfdaf7ff",
  paletteNeutral3Light: "#8f9ed1ff",
  paletteNeutral2Light: "#f8f9fdff",
  paletteNeutral1Light: "#e7eaf8ff",
  paletteBlue3Light: "#31a2ceff",
  paletteGreen2Light: "#c8eedeff",
  paletteGreen1Light: "#1f6648ff",
  paletteGreen0Light: "#248e61ff",
  paletteOrange0Light: "#ffcd38ff",
  paletteOrange3Light: "#ff6b00ff",
  paletteOrange2Light: "#ffe8adff",
  paletteOrange1Light: "#9b5a01ff",
  paletteWhite2Light: "#ecececff",
  paletteWhite3Light: "#d5d5d5ff",
  paletteWhite1Light: "#f7f7f8ff",
  paletteRed0Light: "#d42a36ff",
  paletteRed3Light: "#ff0000ff",
  paletteRed2Light: "#ffe2e2ff",
  paletteRed1Light: "#a30013ff",
  paletteWhite0Light: "#ffffffff",
  paletteBlue1Light: "#0c1457ff",
  paletteBlack0Light: "#000000ff",
  paletteBlack1Light: "#333333ff",
  paletteBlue2Light: "#5c6e9eff",
  paletteBlue0Light: "#0d2976ff",
  palettePrimaryActionLight: "#6ef29cff",
  palettePrimary0Light: "#2358f8ff",
  palettePrimary5Light: "#436fb6ff",
  palettePrimary3Light: "#e7f9feff",
  palettePrimary2Light: "#4b75ffff",
  palettePrimary1Light: "#1531b8ff"
} as const;

export default colors;
